import { Component, Ref, Prop } from '@eastsideco/salvo-ts';
import { ThemeComponent } from '@/theme/ThemeComponent';
import { disableBodyScrolling } from '@/utils/disableBodyScrolling';

declare global {
    interface Window {
        // eslint-disable-next-line @typescript-eslint/naming-convention
        Trustpilot?: {
            loadFromElement(element: HTMLElement, shouldReload: boolean): void;
        };
    }
}

@Component
export class ProductCardQuickAddTrigger extends ThemeComponent {
    @Prop({ default: window.scrollY }) scrollPosition!: number;

    @Ref() buttonQATC!: HTMLButtonElement;

    private quickAdd: HTMLDivElement | null = null;

    init() {
        this.scrollPosition = window.scrollY;
        const productCard = this.closest('.product-card');
        this.quickAdd = productCard?.querySelector('.product-card-quick-add') as HTMLDivElement | null;

        this.setQuickAddListener();
    }

    /**
     * Set quick add listener
     */
    setQuickAddListener() {
        if (this.buttonQATC) {
            this.$listen(this.buttonQATC, 'click', (e) => {
                e.stopPropagation();
                this.handleButton();
                // eslint-disable-next-line max-len
                const reviewsElement = this.closest('.product-card-quick-add')?.querySelector('.product-reviews-js') as HTMLElement;
                if (!reviewsElement) {return;}

                reviewsElement.style.display = 'block'; // unhide container if hidden
            });
        }
    }

    /**
     * Handle quick add state and toggle 'prevent-scroll' class on body
     */
    handleButton() {
        if (this.quickAdd && !this.quickAdd.classList.contains('is-active')) {
            this.quickAdd.classList.add('is-active');

            this.scrollPosition = disableBodyScrolling(true, this.scrollPosition);

            // Notify the quick add component that it has opened (for focus management)
            this.quickAdd.dispatchEvent(new CustomEvent('quickAdd:open', { bubbles: true }));
        }
        const productCard = this.closest('.product-card');
        this.quickAdd = productCard?.querySelector('.product-card-quick-add') as HTMLDivElement | null;

        if(this.quickAdd){
            const trustpilotWidget = this.quickAdd.querySelector('.trustpilot-widget');

            if (window.Trustpilot && trustpilotWidget instanceof HTMLElement) {
                window.Trustpilot.loadFromElement(trustpilotWidget, true);
            }
        }
    }
}
